<template>
  <div v-if="screener">
    <!-- Buy Ticket Button -->
    <v-btn
      v-if="!isScreeningArchive && isScreeningPaid(screener) && (!isConsumerPurchased(screener.id) || isConsumerSubscribed) && !isConsumerEnrolled(screener.id)"
      v-bind="buttonProps"
      color="primary background--text"
      class="mx-0"
      :disabled="screener.is_geo_blocked"
      @click.stop="$emit('onBuyTicket',screener)"
    >
      <template>
        <span v-if="isEmbedMode">{{ $t(`${eventPrefix}.btn.watch`) }}</span>
        <span v-else>{{ $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Watch Button -->
    <v-btn
      v-else-if="isConsumerEnrolled(screener.id)"
      v-bind="buttonProps"
      color="primary background--text"
      class="white--text mx-0"
      :disabled="screener.is_geo_blocked"
      @click.stop="$emit('onWatch',screener)"
    >
      <template>
        <span>{{ $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Participate Button -->
    <v-btn
      v-if="showParticipateMenu()"
      v-bind="buttonProps"
      color="primary background--text"
      class="mx-0"
      :disabled="screener.is_geo_blocked"
      @click.stop="$emit('onParticipate',screener)"
    >
      <template>
        <!-- Show participate only when a user purchased a pass but not enrolled yet -->
        <span>{{ isScreeningPaid(screener) && !isConsumerEnrolled(screener.id) ? $t(`${eventPrefix}.btn.participate`) :  $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Venue event Buy Ticket Button -->
    <v-btn
      v-if="_shouldShowBuyVenueTicketBtn()"
      v-bind="buttonProps"
      color="primary background--text"
      class="mr-0"
      @click.stop="$emit('onBuyVenueTicket',screener)"
    >
      <template>
        <span>{{$t('screener.btn.buy_venue_ticket')}}</span>
      </template>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {isDatePast}  from "@/helpers";
export default {
  name: "ScreenerButton",
  props: {
    screener: {
      type: Object,
      default: null
    },
    buttonProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      isConsumerSubscribed: "isSubscribed"
    }),
    ...mapGetters("app", {
      isEmbedMode: "isEmbedMode",
    }),
    isScreeningArchive: function(){
      //TEMP:: VOD events can't be archived
      if(this.screener.is_vod_event){
        return false;
      }
      return isDatePast(this.screener.registration_ends_at);
    },
    isArchiveMenu: function(){
      return this.$route.name == 'screeners.archive';
    },
    eventPrefix() {
      if(this.screener && this.screener.is_vod_event){
        return 'vod';
      }

      return 'screener'
    }

  },

  methods: {
    showParticipateMenu(){
      if(this.isArchiveMenu){
        return false;
      }

      if(this.isScreeningPaid(this.screener) && !this.isConsumerPurchased(this.screener.id)){
        return false;
      }

      return !this.isConsumerEnrolled(this.screener.id);
    },
    _shouldShowBuyVenueTicketBtn(){
      // If the event is not of both the types, never show
      if(this.screener.event_type != this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL_AND_PHYSICAL){
        return false;
      }

      // If the event is paid and purchased by the user then show
      if(this.isScreeningPaid(this.screener) && this.isConsumerPurchased(this.screener.id)){
        return true;
      }

      // If the event is paid/free & the user is enrolled then show
      if(this.isConsumerEnrolled(this.screener.id)){
        return true;
      }

      // If the event is geo-blocked then show
      if(this.screener.is_geo_blocked){
        return true;
      }
    }
  }
};
</script>

<style>
</style>
